export type ExclusionReasons =
  | 'manuallyexcluded'
  | 'status'
  | 'unmatchedsegments'
  | 'missingdata'
  | 'included';

function getExclusionReason(
  hasMissingData: boolean,
  hasFastFillErrors: boolean,
  status: string,
  isExcluded: boolean
): ExclusionReasons {
  if (isExcluded) return 'manuallyexcluded';
  if (hasMissingData) return 'missingdata';
  if (hasFastFillErrors) return 'unmatchedsegments';
  if (status.toLowerCase() !== 'published') return 'status';
  return 'included';
}

export default getExclusionReason;
